import { credentials } from '../config/brand';

interface TrustBarProps {
  /** `band` renders a full-width bordered strip; `plain` is transparent. */
  variant?: 'band' | 'plain';
  className?: string;
}

function VerifiedIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="m9 12 2 2 4-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2.5 14.4 4.3 17.4 4.1 18.6 6.9 21.3 8.1 21.1 11.1 22.9 13.5 21.1 15.9 21.3 18.9 18.6 20.1 17.4 22.9 14.4 22.7 12 24.5 9.6 22.7 6.6 22.9 5.4 20.1 2.7 18.9 2.9 15.9 1.1 13.5 2.9 11.1 2.7 8.1 5.4 6.9 6.6 4.1 9.6 4.3 12 2.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Credentials strip surfacing verifiable trust signals (certifications,
 * registration, provenance). Data comes from `brand.credentials` so it stays
 * consistent and editable in one place.
 */
export default function TrustBar({ variant = 'band', className = '' }: TrustBarProps) {
  const wrapper =
    variant === 'band'
      ? 'border-y border-slate-100 bg-white'
      : '';

  return (
    <div className={`${wrapper} ${className}`}>
      <div className="container-page">
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 py-5 sm:justify-between">
          {credentials.map((c) => (
            <li key={c.label} className="flex items-center gap-2.5">
              <VerifiedIcon className="h-6 w-6 shrink-0 text-accent-green" />
              <span className="flex flex-col leading-tight">
                <span className="text-sm font-bold text-slate-800">{c.label}</span>
                <span className="hidden text-xs text-slate-500 sm:block">{c.note}</span>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
